import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getCurrentLanguage } from '~/localization';
import { fetchFromOldApi } from '~/services/Http';

import { AllEnums } from './types';

export type StoreState = {
  allEnums: AllEnums;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
};

const initialState: StoreState = {
  allEnums: {},
  isLoading: false,
  failedToLoad: false,
  hasData: false,
};

export enum EnumsActionKeyPrefixes {
  FETCH_ENUMS = 'employees/FETCH_ENUMS',
}

export type EnumsPayload = {
  allEnums: AllEnums;
};

const getAllEnums = async (): Promise<AllEnums> => {
  const currentLanguage = getCurrentLanguage();
  const enumAll = await fetchFromOldApi(
    `/json/enum/ALL/${currentLanguage}`,
  ).then((r) => r.json());
  return enumAll;
};

export const fetchEnums = createAsyncThunk<EnumsPayload, undefined>(
  EnumsActionKeyPrefixes.FETCH_ENUMS,
  async (): Promise<EnumsPayload> => {
    return {
      allEnums: await getAllEnums(),
    };
  },
);

export const enumsSlice = createSlice({
  name: '~/data/enums',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchEnums.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<EnumsPayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.hasData = true;
      state.allEnums = action.payload.allEnums;
    },
    [fetchEnums.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [fetchEnums.rejected.type]: (state: StoreState) => {
      state.failedToLoad = true;
    },
  },
});

export const enumsReducer = enumsSlice.reducer;
